// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"dd31006766--wrapper--QjxQb","content":"dd31006766--content--IkBkP","icon":"dd31006766--icon--CwJWO","link":"dd31006766--link--RgpMv"};